import { SseEvents, SseResultObject } from '../states';
import { createRequestReducer } from './RequestReducer';

export const operationStartedReducer =
  createRequestReducer<SseResultObject[SseEvents.OPERATION_STARTED]>();

export const selfieCapturedReducer =
  createRequestReducer<SseResultObject[SseEvents.SELFIE_CAPTURED]>();

export const facialAuthenticationReducer =
  createRequestReducer<
    SseResultObject[SseEvents.FACIAL_AUTHENTICATION_EVALUATED]
  >();

export const passiveLivenessReducer =
  createRequestReducer<SseResultObject[SseEvents.PASSIVE_LIVENESS_EVALUATED]>();

export const operationFinishedReducer =
  createRequestReducer<SseResultObject[SseEvents.OPERATION_FINISHED]>();

export const operationExpiredReducer =
  createRequestReducer<SseResultObject[SseEvents.OPERATION_EXPIRED]>();
